import { dateTimeMinuteFormatter, hourMinuteFormatter } from '@dreryk/react-common';
import { AutoLayout, ClockIcon, IconFillColor, IconWrapper } from '@dreryk/react-components';

type AppointmentDateTimeProps = {
   readonly beginDate: Date;
   readonly endDate: Date;
};

export const AppointmentDateTime = (props: AppointmentDateTimeProps): JSX.Element => {
   return (
      <AutoLayout as={'div'} $spacing={4} $alignement={'center'} $horizontalResizing={'hug'}>
         <IconWrapper testId={'clock'} fillColor={IconFillColor.BACKGROUND}>
            <ClockIcon />
         </IconWrapper>
         <span>
            {dateTimeMinuteFormatter(props.beginDate)}
            {props.beginDate !== props.endDate && `-${hourMinuteFormatter(props.endDate)}`}
         </span>
      </AutoLayout>
   );
};
